import React, {  useState } from "react";
import "./portfolio.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import Button from "../../buttons/Button";
import "swiper/css";
import { motion } from "framer-motion";
import YouTube from "react-youtube";
import PopPage from "../../PopPage";

const Portfolio = () => {
  return (
    <div className="portfolio">
      <CreativePortfolio />
      <Skills />
      <VideoPlay />
      <ClientSay />
    </div>
  );
};

export default Portfolio;

function CreativePortfolio() {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [displayCount, setDisplayCount] = useState(6); // New state variable

  const data = [
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876258/allec-gomes-ftEtxZjEJX8-unsplash_a6hgwk.jpg",
      name: "My Story",
      link:"https://www.instagram.com/",
      category: "Design",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      name: "Design Trend",
      link:"https://dribbble.com/shots",
      category: "Branding",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876258/allec-gomes-ftEtxZjEJX8-unsplash_a6hgwk.jpg",
      name: "My Story",
      link:"https://www.instagram.com/",
      category: "Design",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      name: "Design Trend",
      link:"https://dribbble.com/shots",
      category: "Branding",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876375/mae-mu-vbAEHCrvXZ0-unsplash_1_ilwkmm.jpg",
      name: "Soft Cream",
      link:"https://dribbble.com/shots",
      category: "Photography",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      name: "Design Trend",
      link:"https://dribbble.com/shots",
      category: "Branding",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876375/mae-mu-vbAEHCrvXZ0-unsplash_1_ilwkmm.jpg",
      name: "Soft Cream",
      link:"https://dribbble.com/shots",
      category: "Photography",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876258/allec-gomes-ftEtxZjEJX8-unsplash_a6hgwk.jpg",
      name: "My Story",
      link:"https://www.instagram.com/",
      category: "Design",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      name: "Design Trend",
      link:"https://dribbble.com/shots",
      category: "Branding",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876258/allec-gomes-ftEtxZjEJX8-unsplash_a6hgwk.jpg",
      name: "My Story",
      link:"https://www.instagram.com/",
      category: "Design",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      name: "Design Trend",
      link:"https://dribbble.com/shots",
      category: "Branding",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876375/mae-mu-vbAEHCrvXZ0-unsplash_1_ilwkmm.jpg",
      name: "Soft Cream",
      link:"https://dribbble.com/shots",
      category: "Photography",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      name: "Design Trend",
      link:"https://dribbble.com/shots",
      category: "Branding",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876375/mae-mu-vbAEHCrvXZ0-unsplash_1_ilwkmm.jpg",
      name: "Soft Cream",
      link:"https://dribbble.com/shots",
      category: "Photography",
    },
  ];
  const categories = ["Design", "Branding", "Photography"];

  const handleLoadMore = () => {
    setDisplayCount(displayCount + 3);
  };

  const filteredItems = selectedCategory
    ? data.filter((item) => item.category === selectedCategory)
    : data;

  function PortfolioCard({ name, category, img, link }) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ type: "tween", duration: 0.5 }}
        className="portfolio-card"
      >
        <div className="img">
          <img src={img} alt="" />
        </div>  
        <div className="hover">
          <a href={link}>{name}</a>
          <span className="category">{category}</span>
        </div>
      </motion.div>
    );
  }

  return (
    <div className="creative-portfolio-wrapper">
      <div className="navigation">
        <h3>Creative Portfolio</h3>
        <ul className="box">
          <li onClick={() => setSelectedCategory("")}>All</li>
          {categories.map((category) => (
            <li onClick={() => setSelectedCategory(category)} key={category}>
              {category}
            </li>
          ))}
        </ul>
      </div>
      <div className="grid">
        {filteredItems.slice(0, displayCount).map((item, index) => (
          <PortfolioCard
            key={index}
            name={item.name}
            category={item.category}
            img={item.img}
            link={item.link}
          />
        ))}
      </div>
      <div className="load-more">
        {filteredItems.length > displayCount && ( // Display "Load More" button conditionally
          <Button onClick={handleLoadMore} name={"Load More"} />
        )}
      </div>
    </div>
  );
}

function Skills() {
  function SkillBox({ name, value }) {
    return (
      <div className="skill-box">
        <div className="top">
          <h3>{name}</h3>
          <h3>{value}</h3>
        </div>
        <span className="line"  >
          <span className="value" style={{width:`${value}`}} ></span>
        </span>
      </div>
    );
  }

  return (
    <div className="skills">
      <div className="left">
        <h3>I have high skills in developing and programming</h3>
        <p>
          I am working on a professional, visually sophisticated and
          technologically proficient, responsive and multi-functional personal
          portfolio template Shane.
        </p>
      </div>
      <div className="right">
          <SkillBox name={'Web Development'} value={'75%'} />
          <SkillBox name={'Ux/Ui Design'} value={'40%'} />
          <SkillBox name={'App Development'} value={'60%'} />
      </div>
    </div>
  );
}

function VideoPlay() {
  const [videoPop, setVideoPop] = useState(false);

  const VideoPlayer = ({ videoId }) => {
    const opts = {
      playerVars: {
        autoplay: 1,
      },
    };

    return <YouTube className="opts" videoId={videoId} opts={opts} />;
  };

  const videoId = "T7MjTDceCAg";

  function VideoPopMiddle() {
    return (
      <PopPage>
        <div className="single-video-wrapper">
          <span className="close-box" onClick={() => setVideoPop(false)}>
            <i className="fa-solid fa-xmark"></i>
          </span>
          <VideoPlayer videoId={videoId} />
        </div>
      </PopPage>
    );
  }

  return (
    <div className="video-play">
      <img
        src="https://res.cloudinary.com/raiusl/image/upload/v1671881173/vadim-artyukhin-7yIrWv-QqFc-unsplash_vrr79v.jpg"
        alt=""
      />
      <div className="overlay">
        <div className="wrapper">
          <span onClick={() => setVideoPop(true)}>
            <i class="fa-sharp fa-solid fa-circle-play"></i>
          </span>
          <h3>I am delivering beautiful digital products for my clients</h3>
        </div>
      </div>
      {videoPop ? <VideoPopMiddle /> : null}
    </div>
  );
}

function ClientSay() {
  function TestoBox() {
    return (
      <div className="testo-box">
        <p>
          The UX/UI theme I recently explored was a true delight,Its sleek
          design and intuitive layout made navigation feel just right.With its
          clean aesthetics and well-organized elements,Interacting with the
          interface became a seamless experience, evident.This theme truly
          embodies the essence of user-centered design.
        </p>
        <div className="avater">
          <div className="img">
            <img
              src="https://res.cloudinary.com/raiusl/image/upload/v1672689092/cesar-rincon-XHVpWcr5grQ-unsplash_ghgczq.jpg"
              alt=""
            />
          </div>
          <div className="text">
            <h4>Rechard banson</h4>
            <span>web developer</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="client-says skills ">
      <div className="left-2">
        <h3>What clients say about my portfolio template</h3>
      </div>
      <div className="right-2">
        <Swiper
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          modules={[Navigation, Autoplay]}
        >
          <SwiperSlide>
            <TestoBox />
          </SwiperSlide>
          <SwiperSlide>
            <TestoBox />
          </SwiperSlide>
          <SwiperSlide>
            <TestoBox />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}
